const TRANSLATIONS = {
    en: {
        nodeName: 'Node Name'
    }
}

export default TRANSLATIONS